// import _ from 'lodash-es';

export const getSelectedFilters = ($el) => {
  console.log('getSelectedFilters');
  
  const new_selected_filters = [];

  $el.find('[data-collection-filter-checkbox]:checked').each((i, item) => {
    const $item = $(item);
    const filter_type = $item.attr('data-filter-type');
    const value = $item.val();

    new_selected_filters.push({
      type: filter_type,
      value,
    });
  });

  return new_selected_filters;
};

export const getFilteredProducts = (products, filters) => {
  const tag_filters = filters.filter((filter) => {
    return filter.type !== 'price' && filter.value !== 'all';
  });

  const price_filters = filters.filter((filter) => {
    return filter.type === 'price' && filter.value !== 'all';
  });

  let filtered_products;

  if (tag_filters.length > 0) {
    filtered_products = products.filter((product) => {
      let match_found = false;
  
      tag_filters.forEach((filter) => {
        const matching_string = `filter-${filter.type}-${filter.value}`
          .toLowerCase()
          .replace(/ /g, '-');
        const tags = String(product.product_json.tags);
  
        if (tags.indexOf(matching_string) > -1) {
          match_found = true;
        }
      });
  
      return match_found;
    });
  } else {
    filtered_products = products;
  }

  // If there were no price filters, then we're done
  if (price_filters.length === 0) { return filtered_products; }

  // After tag matching, filter again for price
  const price_filtered_products = filtered_products.filter((price_product) => {
    let match_found = false;

    price_filters.forEach((price_filter) => {
      const value_array = price_filter.value.split('-');
      const min_price = Number(value_array[0]);
      const max_price = Number(value_array[1]);
      const product_price = Number(price_product.product_json.price) / 100;

      if (product_price >= min_price && product_price <= max_price) {
        match_found = true;
      }
    });
    
    return match_found;
  });

  return price_filtered_products;
};